import { useTranslation } from 'react-i18next';

interface TaskCardDescriptionSectionProps {
    html: string;
}

const TaskCardDescriptionSection = ({ html }: TaskCardDescriptionSectionProps) => {
    const { t } = useTranslation('Tasks');

    return (
        <section className="task-card-section mb-3">
            <div className="task-card-section__label">{t('labelInfo')}</div>
            <div className="task-card-description" dangerouslySetInnerHTML={{ __html: html }} />
        </section>
    );
};

export default TaskCardDescriptionSection;
